import React from "react";
import { DateTime } from "luxon";

export function Footer() {
  return (
    <footer
      className="footer footer-center !bg-neutral text-neutral-content max-md:hidden p-10"
      data-testid="footer"
    >
      <aside>
        <img alt="Docket" className="w-32" src="/assets/images/Docket_Logo_White.png" />
        <p>© {DateTime.now().year} Docket Health, Inc. All rights reserved.</p>
      </aside>
      <nav>
        <div className="flex flex-wrap justify-center gap-4">
          <a className="link link-hover" target="_blank" href="https://dockethealth.com/faqs">
            Immunization FAQs
          </a>
          <a className="link link-hover" target="_blank" href="https://docket.care/terms_of_use">
            Terms of Use
          </a>
          <a className="link link-hover" target="_blank" href="https://docket.care/privacy_policy">
            Privacy Policy
          </a>
          <a className="link link-hover" target="_blank" href="https://docket.care/security">
            Security
          </a>
          <a className="link link-hover" target="_blank" href="https://dockethealth.com">
            Home
          </a>
        </div>
      </nav>
      <nav>
        <div className="flex gap-4">
          <a href="mailto:info@dockethealth.com" className="opacity-80 hover:opacity-100">
            <img alt="Email" className="w-8" src="/assets/images/footer_email.png" />
          </a>
          <a
            href="https://www.linkedin.com/company/foxhall-wythe-llc"
            className="opacity-80 hover:opacity-100"
          >
            <img alt="LinkedIn" className="w-8" src="/assets/images/footer_linkedin.png" />
          </a>
          <a href="https://twitter.com/DocketHealthApp" className="opacity-80 hover:opacity-100">
            <img alt="Twitter" className="w-8" src="/assets/images/footer_twitter.png" />
          </a>
          <a
            href="https://www.instagram.com/dockethealthapp"
            className="opacity-80 hover:opacity-100"
          >
            <img alt="Instagram" className="w-8" src="/assets/images/footer_instagram.png" />
          </a>
        </div>
      </nav>
    </footer>
  );
}
